export enum CameraType {
  SMALL = 'small',
}
